import { render } from "./ProvinceTaskAttachmentForm.vue?vue&type=template&id=06489028&scoped=true&ts=true"
import script from "./ProvinceTaskAttachmentForm.ts?vue&type=script&lang=ts"
export * from "./ProvinceTaskAttachmentForm.ts?vue&type=script&lang=ts"

import "./ProvinceTaskAttachmentForm.scss?vue&type=style&index=0&id=06489028&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06489028"]])

export default __exports__